<template>
  <div class="menu" ref="side">
    <div class="menu-item" v-for="(item, index) in menuArr" :key="index">
      <a class="icon iconfont" href="javascript:;" @click="menuItemClick(item, index)" :class="[item.cls, {'active': item.active, 'angle': item.sub.length > 0}]">{{item.name}}</a>
      <div class="sub-menu" v-show="item.active">
        <div class="sub-menu-item" v-for="(sub, i) in item.sub" :key="sub.id">
          <a class="sub-menu-item-a" href="javascript:void(0);" @click="subMenuItemClick(sub, i, $event.target)">{{sub.name}}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menuList: {
      type: Array,
      required: true
    },
    menuClick: {
      type: Function,
      default: () => {}
    },
    subMenuClick: {
      type: Function,
      default: () => {}
    },
    selectIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      select: 0,
      menuArr: []
    }
  },
  watch: {
    menuList (val) {
      if (val.length > 0) {
        this.menuArr = val.map((item, index) => {
          return Object.assign({}, item, {'active': false})
        })
        this.select = this.selectIndex
        this.$set(this.menuArr[this.select], 'active', true) // 设置第一个菜单项默认展开
        // this.$emit('menu-click', this.menuArr[this.select], this.select) // 向上触发第一个菜单项点击事件
        this.$nextTick(() => { // 设置第一个菜单的第一个子菜单项默认选中
          this.menuGroups = this.$refs.side.getElementsByClassName('menu-item')
          this.menuGroups.length && (this.firstSubMenuGroups = this.menuGroups[this.select].getElementsByClassName('sub-menu-item-a'))
          this.firstSubMenuGroups.lenght && (this.firstSubMenuGroups[this.select].className += ' active')
          this.subMenuGroups = this.$refs.side.getElementsByClassName('sub-menu-item-a')
          this.subMenuGroups.length && (this.subMenuGroups[0].className += ' active')
        })
      }
    }
  },
  methods: {
    clearSideActive (targets) {
      for (let i = 0; i < targets.length; i++) {
        let target = targets[i]
        target.className = target.className.replace(/active/g, '').trim()
      }
    },
    menuItemClick (item, index) {
      this.$emit('menu-click', item, index)
      if (this.select === index) {
        item.sub.length && this.$set(item, 'active', !item.active)
      } else {
        this.select = index
        this.menuArr.forEach((item, i) => {
          if (index === i) {
            this.$set(item, 'active', true)
          } else {
            this.$set(item, 'active', false)
          }
        })
        if (item.sub.length) {
          let target = this.menuGroups[index].getElementsByClassName('sub-menu-item-a')[0]
          this.subMenuItemClick(item.sub[0], 0, target)
        } else {
          this.subMenuItemClick(item.sub[0], 0)
        }
      }
    },
    subMenuItemClick (sub, index, target) {
      this.clearSideActive(this.subMenuGroups)
      target && (target.className += ' active')
      this.$emit('sub-menu-click', sub, index)
    }
  }
}
</script>
<style lang="stylus" scoped>
.menu
  float left
  width 228px
  line-height 58px
  box-shadow 0px 1px 15px 3px rgba(0, 0, 0, 0.16)
  .menu-item
    background-color rgb(43, 158, 252)
    > a
      position relative
      color #fff
      display block
      border-left 4px solid rgb(43, 158, 252)
      border-top 1px solid rgb(71, 171, 253)
      height 58px
      font-size 16px
      background-color rgb(43, 158, 252)
      padding-left 60px
      text-decoration none
      &:hover, &.active
        border-left 4px solid rgb(255, 255, 255)
        background-color rgb(0, 132, 233)
      &:nth-child(0)
        border-top none
      &.icon:before, &.icon:after
        position absolute
        content ''
        display block
        height 18px
        background-repeat no-repeat
        background-position center
      &.database:before
        width 16px
        left 15px
        top 20px
        background-image url(/static/img/database.png)
      &.folder:after
        width 5px
        height 8px
        right 12px
        top 26px
        background-image url(/static/img/arrow.png)
        transition 0.3s
      &.folder:before
        width 20px
        left 15px
        background-image url(/static/img/folder.png)
      &.analysis:before
        content '\e653'
        width 16px
        left 15px
        font-size 20px
      &.case:before
        content '\e636'
        width 16px
        left 15px
        font-size 18px
      &.policy:before
        content '\e704'
        width 16px
        left 15px
        font-size 18px
      &.angle:after
        width 5px
        height 8px
        right 12px
        top 26px
        background-image url(/static/img/arrow.png)
        transition 0.3s
      &.icon.active:after
        transform rotate(90deg)
        -ms-transform rotate(90deg)
      &.folder:before
        width 20px
        left 15px
        top 20px
        background-repeat no-repeat
        background-image url(/static/img/folder.png)
  .sub-menu
    .sub-menu-item
      width 228px
      height 58px
      background-color rgb(71, 171, 253)
      >a
        position relative
        display block
        color #fff
        font-size 14px
        text-decoration none
        padding-left 60px
        &:hover, &.active
          background-color rgba(255, 255, 255, 0.3)
        &:before, &:after
          content ''
          position absolute
          display block
          border-radius 50%
          background-color rgba(255, 255, 255, 1)
        &:before
          width 6px
          height 6px
          left 24px
          top 26px
        &:after
          width 10px
          height 10px
          left 22px
          top 24px
          opacity 0.4

</style>




// WEBPACK FOOTER //
// menubar.vue?76acebf3